import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grimace': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zM344 256c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48h-192c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48h192zM176 352v-24h-40v8c0 8.8 7.2 16 16 16h24zM176 312v-24h-24c-8.8 0-16 7.2-16 16v8h40zM240 352v-24h-48v24h48zM240 312v-24h-48v24h48zM304 352v-24h-48v24h48zM304 312v-24h-48v24h48zM360 336v-8h-40v24h24c8.8 0 16-7.2 16-16zM360 312v-8c0-8.8-7.2-16-16-16h-24v24h40z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grimace.js
// module id = 1749
// module chunks = 0